/**
 * G4b/final-fix (Ayrıca notu) — `fmtCarpan` üç dosyada (OzetSerit/SermayeBlok/AkisBlok) birebir
 * kopyaydı; GMROI/devir hızı gibi ORAN ama YÜZDE DEĞİL çarpanlar için (primitives'in `fmtPct`i
 * sondan % basar, bu ise hiç % basmaz). Tek yere alındı.
 */
export function fmtCarpan(n: number, decimals = 2): string {
  return n.toFixed(decimals).replace('.', ',');
}

/** S352: gün sayısı. 10 günün altı tek ondalıkla ("9,3 gün"), üstü tam sayıyla ("123 gün"). */
export function gunMetni(n: number): string {
  if (n < 10) return `${n.toFixed(1).replace('.', ',')} gün`;
  return `${Math.round(n).toLocaleString('tr-TR')} gün`;
}
